const components = {};

export function registerWidget(name, Component) {
  components[name] = Component;
}

export default function WidgetRegister(props) {
  const C = components[props.type];
  return C ? <C {...props} /> : null;
}
